export default __webpack_public_path__ + "static/media/cw_logo_dark.b4fb474f.png";